import { useTranslation } from 'react-i18next';
import React from 'react';
import { Button } from '../../ui/button';
import { TableCell, TableRow } from '../../ui/table';
import { ChevronUp, ChevronDown, Trash2, GripVertical, Minus } from 'lucide-react';

const SpacerRow = ({
  spacer,
  dates,
  index,
  isDragging,
  isDragOver,
  onDragStart,
  onDragOver,
  onDragLeave,
  onDrop,
  onDragEnd,
  onMoveUp,
  onMoveDown,
  onRemove
}) => {
  const { t } = useTranslation();
  return (
    <TableRow 
      className={`bg-gray-100 ${isDragging ? 'opacity-50' : ''} ${isDragOver ? 'border-t-2 border-blue-500' : ''}`}
      draggable
      onDragStart={(e) => onDragStart(e, index)}
      onDragOver={(e) => onDragOver(e, index)}
      onDragLeave={onDragLeave}
      onDrop={(e) => onDrop(e, index)}
      onDragEnd={onDragEnd}
    >
      <TableCell className="sticky left-0 bg-gray-100 z-10">
        <div className="flex items-center gap-1">
          <div 
            className="cursor-grab active:cursor-grabbing p-1 hover:bg-gray-200 rounded"
            title={t('auto.ctr.dragToReorder')}
          >
            <GripVertical className="h-4 w-4 text-gray-400" />
          </div>
          <div className="flex flex-col gap-0.5">
            <Button
              variant="ghost"
              size="sm"
              className="h-5 w-5 p-0"
              onClick={onMoveUp}
             data-testid="btn-moveup">
              <ChevronUp className="h-3 w-3" />
            </Button>
            <Button
              variant="ghost"
              size="sm"
              className="h-5 w-5 p-0"
              onClick={onMoveDown}
             data-testid="btn-movedown">
              <ChevronDown className="h-3 w-3" />
            </Button>
          </div>
          <div className="flex-1 flex items-center gap-2">
            <Minus className="h-4 w-4 text-gray-400" />
            <span className="text-xs text-gray-500 italic">{spacer.name || 'Spacer'}</span>
          </div>
          <Button
            variant="ghost"
            size="sm"
            className="h-6 w-6 p-0 text-red-500 hover:text-red-700"
            onClick={onRemove}
           data-testid="btn-remove">
            <Trash2 className="h-3 w-3" />
          </Button>
        </div>
      </TableCell>
      {dates.map((date) => (
        <TableCell key={date.toISOString()} className="bg-gray-100" />
      ))}
    </TableRow>
  );
};

export default SpacerRow;
